export default __webpack_public_path__ + "static/media/ilustracao-homem-com-celular-mobile.c470021c.svg";